export enum PanelStatus {
  Active = 'active',
  Inactive = 'inactive',
  Completed = 'completed',
  Warning = 'warning',
}

export type PanelState = {
  isOpen: boolean;
  status: PanelStatus;
};
